/**
 * Password rules for every V2 screen that sets a password: Add User, the Users
 * list reset, the user profile reset (the same dialog) and the self-reset on My
 * Profile.
 *
 * These were copied into four files and had drifted: the user profile dialog
 * checked length only, so it accepted passwords the Users list rejected, and it
 * used a different "123456" rule. The backend enforces neither; it only uses
 * "123456" as a temporary password.
 */

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_PATTERN = /^[A-Za-z0-9]+$/;
/** For the input's `pattern` attribute (no anchors: the browser adds them). */
export const PASSWORD_PATTERN_ATTR = '[A-Za-z0-9]{6,}';
export const PASSWORD_RULE_HINT = 'At least 6 characters, letters and numbers only, no spaces.';

/** 6+ characters, letters and numbers only. */
export function isPasswordFormatValid(pwd) {
  return typeof pwd === 'string'
    && pwd.length >= PASSWORD_MIN_LENGTH
    && PASSWORD_PATTERN.test(pwd);
}

/* Decided 2026-09-30: the "123456" block applies to the user whose password is
   being set when their role id is 1 or 2. It is not tied to role weight. */
const ADMIN_ROLE_IDS = [1, 2];
export const ADMIN_WEAK_PASSWORD_MSG = 'Admin roles cannot use "123456" as a password.';

export function isAdminRoleId(roleId) {
  return ADMIN_ROLE_IDS.includes(parseInt(roleId, 10));
}

/** True when this password is refused for this target role. */
export function isAdminWeakPassword(pwd, targetRoleId) {
  return isAdminRoleId(targetRoleId) && pwd === '123456';
}
